import { render, staticRenderFns } from "./DetalleCartera.vue?vue&type=template&id=78a97dd0"
import script from "./DetalleCartera.vue?vue&type=script&lang=js"
export * from "./DetalleCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports